import { PlusOutlined } from '@ant-design/icons';
import { Button, Col, Form, Row, Table } from 'antd';
import { useCallback, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { IPermission } from '../../../../common/types/commonTypes';
import BreadCrumb from '../../../../components/common/breadCrumb/BreadCrumb';
import { useGetAllAirTicketRefundQuery } from '../../Api/Endpoints/AirTicketRefundEndpoints';

import { debounce, filterNullColumns } from '../../../../common/utils/common.utils';
import usePagination from '../../../../common/utils/usePagination';
import useUrlParams from '../../../../common/utils/useUrlParams';
import { DateInput, FormInput } from '../../../../components/common/FormItem/FormItems';
import Reload from '../../../../components/common/reload/Reload';
import { formatDateRangeArray, parseDateRangeObject } from '../../../../helpers/healper';
import { AirTicketViewUtils } from '../../../../modules/Refund/Utils/AirTicket Utils/AirTicketViewUtils';
import AirticketRowDetails from '../../Components/Airticket/AirticketRowDetails';

type Props = { permission?: IPermission };

const AirticketRefundHistory = ({ permission }: Props) => {
  const [form] = Form.useForm();
  const { setUrlParam, setUrlParamsFromObject, getAllUrlParams } = useUrlParams();
  const { page, size, changePagination, pagination } = usePagination();
  const params_value = getAllUrlParams() as {
    search: string | null;
    from_date: string | null;
    to_date: string | null;
  };

  // GET ALL DATA ,TRASH, DELETE AND RESTORE
  const {
    data,
    isFetching,
    refetch,
    isLoading: dataIsLoading,
  } = useGetAllAirTicketRefundQuery({
    ...getAllUrlParams(),
    page,
    size,
  });
  const dataWithKey = data?.data?.map((item, index) => ({
    key: String(index),
    ...item,
  }));

  const handelSearch = useCallback(
    debounce((e: string) => {
      setUrlParam('search', e);
    }, 600),
    []
  );

  useEffect(() => {
    form.setFieldsValue({
      search: params_value.search,
      date_range: parseDateRangeObject({
        from_date: params_value.from_date,
        to_date: params_value.to_date,
      }),
    });
  }, [params_value]);
  const filteredColumn = filterNullColumns(
    data?.data,
    AirTicketViewUtils({
      permission,
      pagination,
    })
  );
  return (
    <div>
      <BreadCrumb arrOfOption={['Refund', 'AirTicket Refund']} reloaderSize='small' />

      <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 10 }} justify={'space-between'}>
        <Col span={12}>
          <Row gutter={10}>
            {permission?.['create:any'] && (
              <Col xs={24} sm={12} md={8} lg={8}>
                <Link to='/refund/airticket'>
                  <Button type='primary' icon={<PlusOutlined />} style={{ width: '100%' }}>
                    Create
                  </Button>
                </Link>
              </Col>
            )}

            <Col xs={24} sm={12} md={8} lg={8} style={{ display: 'flex' }}>
              <Col>
                <Reload
                  refetch={() => {
                    refetch();
                  }}
                />
              </Col>
            </Col>
          </Row>
        </Col>

        <Col span={12}>
          <Form form={form}>
            <Row justify={'end'} gutter={[10, 10]}>
              <DateInput
                name={'date_range'}
                rangePicker
                size={8}
                noStyle
                onChange={(e: any) => setUrlParamsFromObject(formatDateRangeArray(e))}
              />
              <FormInput
                name={'search'}
                placeholder='Search here ...'
                onChange={(e: string) => handelSearch(e.trim())}
              />
            </Row>
          </Form>
        </Col>
      </Row>
      {/* <FormHeaderTitle title='AirTicket Refund' /> */}

      <div>
        <span style={{ float: 'left', marginBottom: '1rem' }}>
          You have total <strong>{data?.count ? data?.count : data?.data?.length}</strong> rows
        </span>
        <Table
          size='small'
          bordered
          columns={filteredColumn?.col}
          dataSource={dataWithKey}
          pagination={changePagination(data?.count)}
          expandable={{
            rowExpandable: (record) => true,
            expandedRowRender: (record, index) => {
              return <AirticketRowDetails id={record.atrefund_id} />;
            },
          }}
          rowKey={(record, index) => index || 0}
        />
      </div>
    </div>
  );
};

export default AirticketRefundHistory;
